import { CONSENT_CHANGE_EVENT } from "@/hooks/useCookieConsent";
import { track } from "@/lib/analytics/client";
import { getClientConsent } from "@/lib/analytics/consent";
import { getDiscoverSessionProps } from "@/lib/analytics/discover-attribution";
import type { Events } from "@/lib/analytics/events";
import { hasFired, markFired } from "@/lib/analytics/oncePerTab";
import { EMBEDDED_IN_APP_COOKIE } from "@/lib/embeddedInAppCookie";
import Cookies from "js-cookie";

const INTERACTIONS_EVENT = "discover_session__interactions";

export type DiscoverInteractionType =
  | "tab_switch"
  | "search"
  | "map"
  | "date_filter"
  | "radius_filter"
  | "sort_filter"
  | "age_filter"
  | "skill_filter"
  | "price_filter"
  | "membership_filter"
  | "club_type_filter"
  | "location_selector"
  | "activity_selector";

/** Held in memory until the visitor accepts consent, then sent. */
let firstInteraction: Events[typeof INTERACTIONS_EVENT] | null = null;

export function trackFirstDiscoverInteraction(
  type: DiscoverInteractionType,
): void {
  if (typeof window === "undefined") return;
  if (firstInteraction || hasFired(INTERACTIONS_EVENT)) return;

  firstInteraction = {
    interaction_type: type,
    ...getDiscoverSessionProps(
      new URLSearchParams(window.location.search),
      Cookies.get(EMBEDDED_IN_APP_COOKIE) === "true",
    ),
  };
  window.addEventListener(CONSENT_CHANGE_EVENT, sendOnceConsented);
  sendOnceConsented();
}

function sendOnceConsented(): void {
  if (!firstInteraction || getClientConsent() !== "accepted") return;
  window.removeEventListener(CONSENT_CHANGE_EVENT, sendOnceConsented);
  markFired(INTERACTIONS_EVENT);
  track(INTERACTIONS_EVENT, firstInteraction);
}
